import React, { useMemo } from 'react';

import styled from 'styled-components';

import { useCommunityViewContext } from 'components/View/CommunityViewContext';

import ContractRow from './ContractRow';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled.span`
  font-family: var(--font-bold);
  font-size: 11px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--text-primary);
`;

const CompetitorListSection = () => {
  const { competitors, viewFilters } = useCommunityViewContext();
  const selectedCompetitorIds = (viewFilters as { competitors?: number[] } | undefined)?.competitors ?? [];

  const sortedCompetitors = useMemo(() => {
    const pool =
      selectedCompetitorIds.length > 0
        ? (competitors ?? []).filter((competitor) => selectedCompetitorIds.includes(competitor.id))
        : competitors ?? [];

    return [...pool].sort((left, right) =>
      (left?.comunity_name || '').localeCompare(right?.comunity_name || '')
    );
  }, [competitors, selectedCompetitorIds]);

  if (!sortedCompetitors.length) {
    return null;
  }

  return (
    <Container>
      <Title>Competitors</Title>
      {sortedCompetitors.map((competitor) => (
        <ContractRow
          key={competitor.id}
          communityId={competitor.id}
          name={competitor.comunity_name}
          color={competitor.color}
          contracts={competitor.contracts || []}
        />
      ))}
    </Container>
  );
};

export default CompetitorListSection;
